<div class="breadcrumbs-container" *ngIf="currentRoute.indexOf('user-profile')  == -1">
    @for(route of routeList; track route; let index = $index){
    <div class="bold" style="padding-left: 0;">
        @if((index == routeList.length - 1) || route.name.toLowerCase() == 'edit'){
        {{route.name | titlecase}}
        }
        @else{
            <a
            [routerLink]="getRouteLink(route.url).path"
            [queryParams]="getRouteLink(route.url).queryParams"
            class="breadcrumb-link"
          >
            {{ route.name | customTitleCasePipe }}
          </a> 
        }
    </div>
    <span class="breadcrumb-arrow" *ngIf="routeList.length != 1 && index < routeList.length - 1">
        /
    </span>
    }
</div>